import { clientConfig } from '@/config/clientConfig';

const BUCKET_URL = clientConfig.assetsUrl;
const UPLOAD_API_URL = '/api/store';

type ResultSuccess = {
  success: true;
  fileKey: string;
};
type ResultError = {
  success: false;
  fileKey?: string;
};

type Result = ResultSuccess | ResultError;

export const isSuccessUpload = (data: Result): data is ResultSuccess => data.success;

export const awsStoreService = {
  getAttachmentObjectUrl: (name: string) => `${BUCKET_URL}/attachments/${name}`,
  getDocObjectUrl: (name: string) => `${BUCKET_URL}/doc/${name}`,

  uploadFile: async (file: File): Promise<Result> => {
    try {
      const formData = new FormData();
      formData.set('file', file);

      const res = await fetch(UPLOAD_API_URL, {
        method: 'POST',
        body: formData,
      });

      if (!res.ok) {
        console.log(await res.text());
        return { success: false };
      }
      const data = await res.json();
      return { success: true, fileKey: data.fileKey };
    } catch (e: unknown) {
      console.log(e);
      throw e;
    }
  },

  removeFile: async (fileKey: string): Promise<boolean> => {
    try {
      const formData = new FormData();
      formData.set('filekey', fileKey);

      await fetch(UPLOAD_API_URL, {
        method: 'DELETE',
        body: formData,
      });

      return true;
    } catch (e: unknown) {
      console.error(e);
      return false;
    }
  },
};
